export const AUTOCOLONS_SET_ITEMS = 'AUTOCOLONS_SET_ITEMS';
export const DIVISION_SET_ITEMS = 'DIVISION_SET_ITEMS';
export const AUTOCOLON_SELECT_ITEM = 'AUTOCOLON_SELECT_ITEM';
export const AUTOCOLON_SEARCH_VALUE = 'AUTOCOLON_SEARCH_VALUE';
export const AUTOCOLON_SET_ITEM = 'AUTOCOLON_SET_ITEM';
export const AUTOCOLON_ADD_ITEM = 'AUTOCOLON_ADD_ITEM';
export const DIVISION_ADD_ITEM = 'DIVISION_ADD_ITEM';
export const AUTOCOLON_DELETE_ITEM = 'AUTOCOLON_DELETE_ITEM';
export const DIVISION_DELETE_ITEM = 'DIVISION_DELETE_ITEM';
export const DIVISION_SET_ITEM = 'DIVISION_SET_ITEM';
export const GEOFENSE_SET_SEARCH_VALUE = 'GEOFENSE_SET_SEARCH_VALUE';
export const SET_IS_HISTORY_OPEN = 'SET_IS_HISTORY_OPEN';
export const SET_HISTORY_PERIOD_START = 'SET_HISTORY_PERIOD_START';
export const SET_HISTORY_PERIOD_END = 'SET_HISTORY_PERIOD_END';
export const NOTIFICATION_DELETE_ALL_ITEMS = 'NOTIFICATION_DELETE_ALL_ITEMS';
export const NOTIFICATION_DELETE_ALL_QUEUE = 'NOTIFICATION_DELETE_ALL_QUEUE';
export const SET_HISTORY_SELECTED_TIME = 'SET_HISTORY_SELECTED_TIME';
export const MAP_SET_TRANSPORT_HISTORY_ITEMS_CONDITIONS = 'MAP_SET_TRANSPORT_HISTORY_ITEMS_CONDITIONS';
export const SET_TRANSPORT_SELECTED_DATE = 'SET_TRANSPORT_SELECTED_DATE';
export const SET_TRANSPORT_HISTORY_TRACKS_ITEMS = 'SET_TRANSPORT_HISTORY_TRACKS_ITEMS';
export const SET_HISTORY_TRACKS_VISIBLE = 'SET_HISTORY_TRACKS_VISIBLE';
